<script>
import {createMockPackage, fetchSummary, getMatchedSKU} from "@/api/system/customer";
import {copyToClipboard} from "@/utils/copyClick";
import getLodop from "@/utils/lodop";

export default {
  name: 'Printer',
  inject: ["$page"],
  props: {
    batchNumber: {
      type: Object
    }
  },
  data() {
    return {
      availablePrinter: [],
      selectPrinter: 0,
    }
  },
  methods: {
    changePrinter() {
      window.localStorage.setItem('DefaultPrinterIndex', this.selectPrinter)
      this.$Message.success('默认打印机配置成功')
      setTimeout(() => {
        this.$page.getModal('showPrinter').close()
      }, 2000)
    }
  },
  mounted() {
    let lodop = getLodop(this), printerSize = lodop.GET_PRINTER_COUNT()
    for (let i = 0; i < printerSize; i++) {
      this.availablePrinter.push({index: i, label: lodop.GET_PRINTER_NAME(i)})
    }
    let cachePritnerIndex = window.localStorage.getItem('DefaultPrinterIndex')
    if (cachePritnerIndex) {
      this.selectPrinter = parseInt(cachePritnerIndex)
    }
  }
}
</script>

<template>
  <Form :label-width="120">
    <FormItem label="可用打印机" prop="name">
      <Select v-model="selectPrinter">
        <Option v-for="item in availablePrinter" :value="item.index" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem>
      <Button type="primary" @click="changePrinter">切换打印机</Button>
    </FormItem>
  </Form>
</template>

<style scoped>
.tips {
  padding: 5px 10px;
  margin-bottom: 5px;
}

.text-center {
  text-align: center;
}

.spin {
  margin-bottom: 5px;
}

.small-tips {
  margin-right: 5px;
}
</style>
